import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Row, Col, Button } from 'react-bootstrap';
import NavCreative from 'components/NavCreative';
import { DashboardOutlined } from '@material-ui/icons';
import { api } from 'services';

const DashboardCreative = ({ location }) => {
  const user = JSON.parse(localStorage.getItem("user")) ?? {}
  const defaultFilters = { status_id: '', page: 1, per_page: 10 };
  const [data, setData] = useState({ data: [] });
  const [filters, setFilters] = useState(defaultFilters);
  const [steps, setSteps] = useState([]);

  const { t } = useTranslation();

  useEffect(() => {
    api.get('flows/3/actions-count').then(({ data }) => {
      setSteps(data.steps);
      setFilters({ ...filters, status_id: `${data.steps[0].status.id}`, page: 1 });
    });
  }, []);

  useEffect(() => {
    if (!!filters.status_id) {
      if (filters.department === "") {
        delete filters.department;
      }

      if (filters.status_id == 26) {
        filters['action_status_id'] = 26;
      }

      if (filters.delivery_date_from && !filters.delivery_date_to) {
        return;
      }

      api
        .get('get-actions-tasks-creation', { params: { ...filters } })
        .then(({ data }) => {
          setData(data)
        });
    }
  }, [filters]);

  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters };

    if (reset) f = { ...defaultFilters, ...new_filters };

    setFilters(f);
  };

  return (
    <>
      <Row>
        <Col className="d-flex mt-3 mb-3">
          <DashboardOutlined className="icon-title" />
          <h4 className="title-dashboard mt-2">{t('title:dashboard')}</h4>
        </Col>
      </Row>
      <Row>
        <Col>
          <NavCreative
            statuses={steps.map((step) => ({
              ...step.status,
              ...{ count: step.action_comprovations_count },
            }))}
            filters={[]}
            setFilters={setFilters}
            stateFilters={filters}
            data={data}
            handleFilterChange={handleFilterChange}
            actions={[
              (action, k) => {
                if (user.profiles[0].id == 13 || action.enabled_send_arts || action.action_comprovations) {
                  return (
                    <Link
                      to={{
                        pathname: `creative/show/${action.id}`
                      }}
                    >
                      <Button
                        key={k}
                        size="sm"
                        variant="light"
                        alt={t('label:edit')}
                        title={t('label:edit')}
                      >
                        <i className="fas fa-pen" />
                      </Button>
                    </Link>
                  );
                }
              },
            ]}
          />
        </Col>
      </Row>
    </>
  );
};

export default DashboardCreative;
